export const CURRENT_VERSION = "0.6 beta";
